<template>
  <b-modal centered id="deal-update" title="Update FUB Deal" @shown="getDeal" hide-footer>
    <p class="text-center">Would you like to update the associated FUB deal?</p>
    <div class="text-center" v-if="!showDeal">
      <b-button variant="danger" @click="closeDeal">No</b-button>
      <b-button variant="success" @click="showDeal = true">Yes</b-button>
    </div>

    <div v-if="showDeal">
      <h3 class="text-center" v-if="dealName">{{ dealName }}</h3>

      <b-form-group label="Deal Stage" v-if="stages.length > 0">
        <b-input-group>
          <b-select v-model="deal.stageId">
            <b-select-option :value="null">Select A Stage</b-select-option>
            <b-select-option :value="stage.id" v-for="stage in stages" :key="stage.id">{{ stage.name }}</b-select-option>
          </b-select>
        </b-input-group>
      </b-form-group>

      <h4>The following deal information will be updated.</h4>
      <b-list-group class="mb-3">
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Stage:</strong> {{ stage ? stage.name : '' }}
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Price:</strong> 
          <span v-if="deal.price !== transaction.sale_price"><strike class="text-danger">{{ deal.price | currency }}</strike> {{ transaction.sale_price | currency }}</span>
          <span v-else>
            {{ deal.price | currency }}
          </span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Commission:</strong>
          <span v-if="deal.commissionValue !== commission"><strike class="text-danger">{{ deal.commissionValue | currency }}</strike> {{ commission | currency }}</span>
          <span v-else>
            {{ deal.commissionValue | currency }}
          </span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Close Date:</strong> {{ deal.projectedCloseDate }}
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Active Date:</strong>
          <span v-if="deal.customClarityNOWActiveDate !== transaction.active_date"><strike class="text-danger">{{ new Date(deal.customClarityNOWActiveDate) | date('MM/dd/yyy') }}</strike></span>
          <span v-else>{{ new Date(deal.customClarityNOWActiveDate) | date('MM/dd/yyy') }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Expiration Date:</strong>
          <span v-if="deal.customClarityNOWExpirationDate !== transaction.expiration_date"><strike class="text-danger">{{ new Date(deal.customClarityNOWExpirationDate) | date('MM/dd/yyy') }}</strike></span>
          <span v-else>{{ new Date(deal.customClarityNOWExpirationDate) | date('MM/dd/yyy') }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Listing Date:</strong>
          <span v-if="deal.customClarityNOWListingDate !== transaction.listing_date"><strike class="text-danger">{{ new Date(deal.customClarityNOWListingDate) | date('MM/dd/yyy') }}</strike></span>
          <span v-else>{{ new Date(deal.customClarityNOWListingDate) | date('MM/dd/yyy') }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Ratified Contract Date:</strong>
          <span v-if="deal.customClarityNOWRatifiedContractDate !== transaction.contract_date"><strike class="text-danger">{{ new Date(deal.customClarityNOWRatifiedContractDate) | date('MM/dd/yyy') }}</strike></span>
          <span v-else>{{ new Date(deal.customClarityNOWRatifiedContractDate) | date('MM/dd/yyy') }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Target MLS Date:</strong>
          <span v-if="deal.customClarityNOWTargetMLSDate !== transaction.target_mls_date"><strike class="text-danger">{{ new Date(deal.customClarityNOWTargetMLSDate) | date('MM/dd/yyy') }}</strike></span>
          <span v-else>{{ new Date(deal.customClarityNOWTargetMLSDate) | date('MM/dd/yyy') }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Sale Type:</strong>
          <span v-if="deal.customClarityNOWSaleType !== transaction.sale_type"><strike class="text-danger">{{ deal.customClarityNOWSaleType }}</strike> {{ transaction.sale_type }}</span>
          <span v-else>{{ deal.customClarityNOWSaleType }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Status:</strong>
          <span v-if="deal.customClarityNOWStatus !== transaction.status"><strike class="text-danger">{{ deal.customClarityNOWStatus | capitalize }}</strike>{ { transaction.status | capitalize }}</span>
          <span v-else>{{ deal.customClarityNOWStatus | capitalize }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between">
          <strong>Custom ClarityNOW Transaction Type:</strong>
          <span v-if="deal.customClarityNOWTransactionType !== transaction.transaction_type"><strike class="text-danger">{{ deal.customClarityNOWTransactionType }}</strike> {{ transaction.transaction_type }}</span>
          <span v-else>{{ deal.customClarityNOWTransactionType }}</span>
        </b-list-group-item>
      </b-list-group>
      <b-button block variant="success" @click="updateDeal">Update Deal</b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
  props: {
    transaction: null,
    deal_id: null,
    userRoute: null,
    commission: null,
  },
  data() {
    return {
      deal: {},
      dealName: null,
      showDeal: false,
      pipelines: [],
      people: [],
      users: []
    }
  },
  computed: {
    stages() {
      if (this.deal && this.deal.pipelineId) {
        return this.pipelines.filter(pipeline => {
          return pipeline.id == this.deal.pipelineId;
        })[0].stages;
      } else {
        return [];
      }
    },
    stage() {
      if (this.stages.length > 0) {
        return this.stages.filter(stage => {
          return stage.id == this.deal.stageId
        })[0];
      } else {
        return null;
      }
    }
  },
  methods: {
    getDeal() {
      if (this.deal_id) {
        axios.get(this.userRoute + "/integrations/fub/deals/" + this.deal_id)
        .then(response => {
          this.dealName = response.data.name;
          this.deal.pipelineId = response.data.pipelineId;
          this.deal.stageId = response.data.stageId;
        })
        .catch(error => {
          // error
        });
      }
    },
    closeDeal() {
      this.$bvModal.hide('deal-update');
    },
    updateDeal() {
      axios.post(this.userRoute + "/integrations/fub/deals/" + this.deal_id, {
        price: this.transaction.sale_price,
        projectedCloseDate: this.transaction.close_date,
        commissionValue: this.commission,
        customClarityNOWActiveDate: this.transaction.active_date,
        customClarityNOWExpirationDate: this.transaction.expiration_date,
        customClarityNOWListingDate: this.transaction.listing_date,
        customClarityNOWRatifiedContractDate: this.transaction.contract_date,
        customClarityNOWSaleType: this.transaction.sale_type,
        customClarityNOWStatus: this.transaction.status,
        customClarityNOWTargetMLSDate: this.transaction.target_mls_date,
        customClarityNOWTransactionType: this.transaction.transaction_type,
        pipelineId: this.deal.pipelineId,
        stageId: this.deal.stageId
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$router.go(-1);
        });
      })
      .catch(error => {
        // error
      });
    },
    getPipelines() {
      axios.get(this.userRoute + "/integrations/fub/pipelines")
      .then(response => {
        this.pipelines = response.data;
      })
      .catch(error => {
        // error
      });
    },
  },
  created() {
    this.getPipelines();
  },
  watch: {
    transaction(to, from) {
      this.deal = {
        price: this.transaction.sale_price,
        projectedCloseDate: this.transaction.close_date,
        commissionValue: this.commission,
        customClarityNOWActiveDate: this.transaction.active_date,
        customClarityNOWExpirationDate: this.transaction.expiration_date,
        customClarityNOWListingDate: this.transaction.listing_date,
        customClarityNOWRatifiedContractDate: this.transaction.contract_date,
        customClarityNOWSaleType: this.transaction.sale_type,
        customClarityNOWStatus: this.transaction.status,
        customClarityNOWTargetMLSDate: this.transaction.target_mls_date,
        customClarityNOWTransactionType: this.transaction.transaction_type,
        pipelineId: null,
        stageId: null
      }
    }
  }
};
</script>